import { Component, EventEmitter, Inject, Output, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SwitchProjectsData } from "../switch-project.component";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { Router } from "@angular/router";

export interface DialogData {
  projectList: SwitchProjectsData[];
  selectedProject: string | number;
}

@Component({
  selector: 'switch-project-dialog',
  templateUrl: 'switch-project-dialog.html',
  styles: ['.switch-project-dialog .ps > .ps__rail-x, .switch-project-dialog .ps > .ps__rail-y { opacity: 0.6; }'],
  encapsulation: ViewEncapsulation.None
})
export class SwitchProjectDialog {
  public psConfig: PerfectScrollbarConfigInterface = {};
  projects: SwitchProjectsData[] = [];
  currentProject: SwitchProjectsData;
  selectedProjectId: string | number;

  @Output("change")
  projectChangeEmitter: EventEmitter<string> = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<SwitchProjectDialog>,
    @Inject(MAT_DIALOG_DATA) data: DialogData,
    private router: Router,) {
    this.projects = data.projectList;
    this.currentProject = this.projects.find(x => x.id == data.selectedProject);
    this.selectedProjectId = this.currentProject.id;
  }

  switchProject(projectId) {
    this.currentProject = this.projects.find(x => x.id == projectId);
    this.projectChangeEmitter.emit(projectId);
    this.dialogRef.close(projectId)
  }


}